/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MessageCircle = [
  "svg",
  defaultAttributes,
  [["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z" }]]
];

export { MessageCircle as default };
//# sourceMappingURL=message-circle.js.map
